import { render, staticRenderFns } from "./yikaipiaoSR.vue?vue&type=template&id=8defd238&scoped=true&"
import script from "./yikaipiaoSR.vue?vue&type=script&lang=js&"
export * from "./yikaipiaoSR.vue?vue&type=script&lang=js&"
import style0 from "./yikaipiaoSR.vue?vue&type=style&index=0&id=8defd238&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8defd238",
  null
  
)

export default component.exports